import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
class AEBasketFeedback extends Component {
  #controller;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    document.addEventListener(ThemeEvents.cartUpdate, (event) => {
      if (event.detail?.data?.source !== 'product-form-component' || event.detail?.data?.didError) return;
      this.hidden = false;
    }, options);
    this.querySelector('button')?.addEventListener('click', () => { this.hidden = true; }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.hidden = true;
    }, options);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }
}
if (!customElements.get('ae-basket-feedback')) customElements.define('ae-basket-feedback', AEBasketFeedback);
